// extracted by mini-css-extract-plugin
export default {"accomplish":"Accomplish_accomplish__YbGWH","grid_container":"Accomplish_grid_container__zMlf2","span":"Accomplish_span__Hf2wv"};